<div class="nav-wrapper">
  <div class="nav-action">
    <div
      class="circle"
      [class.active]="isActive('/search')"
      (click)="onNavigate('/search')"
      pTooltip="Search"
    >
      <mat-icon class="material-icons-outlined">search</mat-icon>
    </div>
  </div>
  <div class="nav-action">
    <div
      class="circle"
      [class.active]="isActive('/building-table')"
      (click)="onNavigate('/building-table')"
      pTooltip="Building list"
    >
      <mat-icon>list</mat-icon>
    </div>
  </div>
  <div class="nav-action">
    <div
      class="circle"
      [class.active]="isActive('/documents')"
      (click)="onNavigate('/documents')"
      pTooltip="Document list"
    >
      <mat-icon class="material-icons-outlined">source</mat-icon>
    </div>
  </div>
  <div class="nav-action">
    <div
      class="circle"
      [class.active]="isActive('/admin')"
      (click)="onNavigate('/admin')"
      pTooltip="Admin center"
    >
      <mat-icon class="material-icons-outlined">manage_accounts</mat-icon>
    </div>
  </div>
  <div class="spacer"><ng-content></ng-content></div>
  <div class="page-actions" *ngIf="pageActions?.length">
    <div class="nav-action" *ngFor="let action of pageActions">
      <div
        class="circle"
        [style]="action.style"
        (click)="action.onClick()"
        [pTooltip]="action.tooltip"
      >
        <mat-icon class="material-icons-outlined">{{ action.icon }}</mat-icon>
      </div>
    </div>
  </div>
  <div class="nav-action">
    <div
      class="circle"
      (click)="menuTrigger.toggleMenu()"
      pTooltip="Account details"
    >
      <mat-icon class="material-icons-outlined">person</mat-icon>
    </div>
    <div [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger"></div>
    <mat-menu #menu="matMenu" class="user-mat-menu">
      <app-user-info></app-user-info>
    </mat-menu>
  </div>
</div>
